import React from "react";
import { Table } from "@dossier/salvia-ui";

export default function MinibeakConfig() {
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Default</th>
            <th>Description</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <code>apiPath</code>
            </td>
            <td>string</td>
            <td>/profile/jsonapi</td>
            <td>Path to the api server</td>
          </tr>
          <tr>
            <td>
              <code>path</code>
            </td>
            <td>string</td>
            <td></td>
            <td>
              Relative path to the specific endpoint with leading slash, for
              example <code>"/orgUnits"</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>queryParams</code>
            </td>
            <td>Map of keys to values</td>
            <td></td>
            <td>
              JavaScript object that will be serialized into the URL as query
              params
            </td>
          </tr>
          <tr>
            <td>
              <code>include</code>
            </td>
            <td>array of strings</td>
            <td></td>
            <td>List of linked resources to include</td>
          </tr>
          <tr>
            <td>
              <code>minibeakCache</code>
            </td>
            <td>
              boolean or cache tag string or number of timeout seconds, or array
              of some combination
            </td>
            <td>
              <code>false</code>
            </td>
            <td>Enables request caching</td>
          </tr>
          <tr>
            <td>
              <code>body</code>
            </td>
            <td>json-like data</td>
            <td>
              <code></code>
            </td>
            <td>
              Body of the request (for POST etc). For example:{" "}
              <code>
                {"{"}data: {"{"}
                type: "session", attributes: {"{"}
                employmentId, delegatorEmploymentId
                {"}"}
                {"}"}
              </code>
            </td>
          </tr>
          <tr>
            <td colSpan={4}>
              Also supports any other fields supported by{" "}
              <a href="https://developer.mozilla.org/en-US/docs/Web/API/Request">
                the HTTP fetch request API
              </a>
              , including:
            </td>
          </tr>
          <tr>
            <td>
              <code>method</code>
            </td>
            <td>string</td>
            <td>
              <code>"GET"</code>
            </td>
            <td>Which HTTP method to use</td>
          </tr>
          <tr>
            <td>
              <code>shouldExecute</code>
            </td>
            <td>boolean</td>
            <td>
              <code>true</code>
            </td>
            <td>
              If <code>true</code>, the request will be executed. If{" "}
              <code>false</code>, it will be delayed until it is set to{" "}
              <code>true</code>.
            </td>
          </tr>
          <tr>
            <td>
              <code>throwErrors</code>
            </td>
            <td>boolean</td>
            <td>
              <code>false</code>
            </td>
            <td>
              Hooks only. If <code>true</code>, <code>useProFile</code> and{" "}
              <code>useProFileIncrementally</code> throw the request error
              during render, so the nearest React error boundary catches it,
              instead of returning it in the result. Ignored by{" "}
              <code>callProFile</code>, which always rejects on a failed
              request.
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}
